import React, { useMemo } from 'react';
import { format } from 'date-fns';
import type { ILeave } from '../../types/leave';
import {
  leaveActorDisplayName,
  leaveHistorySummary,
  leaveTypeLabel,
} from '../../constants/leave';
import styles from './LeaveTrackingModal.module.scss';

type Props = {
  leave: ILeave,
  onClose: () => void,
};

const formatEventAt = (iso: string) => {
  try {
    return format(new Date(iso), 'dd/MM/yyyy HH:mm');
  } catch {
    return '-';
  }
};

const formatDay = (iso: string) => {
  try {
    return format(new Date(iso), 'dd/MM/yyyy');
  } catch {
    return '-';
  }
};

const LeaveTrackingModal = ({ leave, onClose }: Props) => {
  const rows = useMemo(() => {
    const list = [...(leave.history ?? [])];
    list.sort((a, b) => new Date(a.at).getTime() - new Date(b.at).getTime());
    return list;
  }, [leave.history]);

  return (
    <div className={styles.root}>
      <h4 className={styles.title}>Détail du suivi</h4>
      <p className={styles.sub}>
        Du {formatDay(leave.startDate)}, retour le {formatDay(leave.endDate)}
      </p>
      <p className={styles.sub}>
        Type : {leaveTypeLabel(leave.leaveType, leave.leaveTypeComment)}
      </p>

      {rows.length === 0 ? (
        <p className={styles.empty}>Aucun événement enregistré pour cette demande.</p>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Utilisateur</th>
                <th>Évolution du statut</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row._id || `${row.at}-${row.kind}`}>
                  <td>{formatEventAt(row.at)}</td>
                  <td>{leaveActorDisplayName(row.actor)}</td>
                  <td>{leaveHistorySummary(row)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className={styles.actions}>
        <button type="button" onClick={onClose}>
          Fermer
        </button>
      </div>
    </div>
  );
};

export default LeaveTrackingModal;
